module.exports = __webpack_public_path__ + "img/food1.99286069.png";